import React from "react";
import Result from "../components/Result";

const PaymentFailure = () => {
  return <Result type="payment" result="failure" />;
};

export default PaymentFailure;
